import { faStar as faStarEmpty } from "@fortawesome/free-regular-svg-icons";
import { faStar as faStarFull, faStarHalfStroke } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";

export const Stars = memo(({ rating = 0, max = 5 }) => {
    const safeRating = Math.min(Math.max(Number(rating) || 0, 0), max);
    const fullStars = Math.floor(safeRating);
    const halfStar = safeRating - fullStars >= 0.5;
    const emptyStars = Math.max(0, max - fullStars - (halfStar ? 1 : 0));

    return (
        <div className="stars_container">
            {[...Array(fullStars)].map((_, i) => (
                <FontAwesomeIcon
                    key={"f" + i}
                    icon={faStarFull}
                    style={{ marginRight: 2 }}
                />
            ))}
            {halfStar && (
                <FontAwesomeIcon
                    key="h"
                    icon={faStarHalfStroke}
                    style={{ marginRight: 2 }}
                />
            )}
            {[...Array(emptyStars)].map((_, i) => (
                <FontAwesomeIcon
                    key={"e" + i}
                    icon={faStarEmpty}
                    style={{ marginRight: 2 }}
                />
            ))}
        </div>
    );
});